import React, { Suspense, useState } from 'react';
import PropTypes from 'prop-types';
import { httpDeleteUserCourse } from '../../Hooks/admin/admin.delete.hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
// Lazy load the DestructiveButton component
const DestructiveButton = React.lazy(
  () =>
    import(
      '../../Components/Buttons/DestructiveButton/DestructiveButton.component'
    )
);
// Admin only
const DeleteCourseFromUser = ({ userId, courseId }) => {
  const [status, setStatus] = useState('');
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ userId, courseId }) =>
      httpDeleteUserCourse(userId, courseId),
    onSuccess: async (data) => {
      let message = await data.json();
      queryClient.invalidateQueries(['users', userId]);
      setStatus(message.msg || 'User has been updated');
    },
    onError: async (error) => {
      let err = await error.json();
      console.error('Error updating user:', error);
      setStatus(err.msg || 'Failed to update user');
    },
  });

  const handleDelete = async (e) => {
    e.preventDefault();
    setStatus('Deleting course from user...');
    mutation.mutate({ userId, courseId });
  };

  return (
    <div
      style={{
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        width: '100%',
        marginTop: '2rem',
        // border: '1px solid #ccc',
      }}
    >
      <div
        style={{
          width: 'auto',
        }}
      >
        {mutation.isPending && <p>Deleting course...</p>}
        {status && <p className="result">{status}</p>}
        {/* Lazy load the DestructiveButton component */}
        <Suspense fallback={<p>Loading button...</p>}>
          <DestructiveButton
            span="Remove course from user"
            functionName={handleDelete}
          />
        </Suspense>
      </div>
    </div>
  );
};

DeleteCourseFromUser.propTypes = {
  userId: PropTypes.string,
  courseId: PropTypes.string,
  setStatus: PropTypes.func,
};

export default DeleteCourseFromUser;
